// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","656":"component---src-templates-single-tsx"}[chunkId] || chunkId) + "-" + {"245":"d53f9cdc7afd866db522","452":"df6518bb59214284e244","453":"7303f0ac2ae2e547e4c4","656":"24e0b64199c3360aad2a","896":"70b3d2144c22b4d74c49"}[chunkId] + ".js";
};